
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from '@/hooks/use-toast';
import { useCartStore } from '@/store/useCartStore';

interface FlutterwavePaymentProps {
  customerInfo: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
  };
  amount: number;
  currency: string;
  ref: string;
}

export const useFlutterwavePayment = () => {
  const navigate = useNavigate();
  const { clearCart } = useCartStore();

  const makePayment = useCallback(({ customerInfo, amount, currency, ref }: FlutterwavePaymentProps) => {
    // Validate required fields
    if (!customerInfo.email || !customerInfo.firstName || amount <= 0) {
      toast({
        title: "Missing Information",
        description: "Please fill in all required fields before proceeding with payment.",
        variant: "destructive"
      });
      return;
    }

    // @ts-ignore
    if (window.FlutterwaveCheckout) {
      // @ts-ignore
      window.FlutterwaveCheckout({
        public_key: "FLWPUBK_TEST-296c30f84f5b0680d346378bfa997635-X",
        tx_ref: ref,
        amount,
        currency: currency || "RWF",
        payment_options: "card, mobilemoneyghana, ussd",
        customer: {
          email: customerInfo.email,
          phone_number: customerInfo.phone,
          name: `${customerInfo.firstName} ${customerInfo.lastName}`,
        },
        customizations: {
          title: "Ahavex Store",
          description: "Payment for items in cart",
          logo: "https://st2.depositphotos.com/4403291/7418/v/450/depositphotos_74189661-stock-illustration-online-shop-log.jpg",
        },
        callback: function(response: any) {
          // Handle successful payment
          if (response.status === "successful") {
            clearCart();
            toast({
              title: "Payment Successful",
              description: "Your order has been placed successfully."
            });
            navigate('/');
          } else {
            toast({
              title: "Payment Failed",
              description: "Your payment could not be processed. Please try again.",
              variant: "destructive"
            });
          }
        },
        onclose: function() {
          // Handle when customer closes payment modal
        }
      });
    } else {
      toast({
        title: "Payment Integration Error",
        description: "There was an error loading the payment system. Please try again later.",
        variant: "destructive"
      });
    }
  }, [clearCart, navigate]);

  return { makePayment };
};
